import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import myAxios from '../../../../lib/axios';


const initialState = {
    data: [],
};

export const fetchTeamMember = createAsyncThunk(
    'user/fetchTeamMember',
    async (query) => {
        try {
            const response = await myAxios.get(`/masters/team-member`);
            return { success: true, message: "Team Member fetched successfully!", data: response?.data?.teamMembers  };
        } catch (error) {
            if (error?.response?.data) {
                return { success: false, message: error?.response?.data?.message };
            } else {
                return { success: false, message: 'Sorry, something went wrong!' };
            }
        }
    },
);


export const createTeamMember = createAsyncThunk(
    'masters/createTeamMember',
    async (data) => {
        try {
            const response = await myAxios.post(`/masters/team-member`,  data?.formData);

            return { success: true, message: "TeamMember added successfully!", data: response?.data };
        } catch (error) {
            if (error?.response?.data) {
                return { success: false, message: error?.response?.data?.message };
            } else {
                return { success: false, message: 'Sorry, something went wrong!' };
            }
        }
    },
);

export const updateTeamMember = createAsyncThunk(
    'masters/updateTeamMember',
    async (data) => {
        try {
            const response = await myAxios.put(`/masters/team-member/${data?.query?.teamMemberId}`, data?.formData);

            return { success: true, message: "TeamMember updated successfully!", data: response?.data };
        } catch (error) {
            if (error?.response?.data) {
                return { success: false, message: error?.response?.data?.message };
            } else {
                return { success: false, message: 'Sorry, something went wrong!' };
            }
        }
    },
);

export const deleteTeamMember = createAsyncThunk(
    'masters/deleteTeamMember',
    async (query) => {
        try {
            const response = await myAxios.delete(`/masters/team-member/${query.teamMemberId}`);

            return { success: true, message: "TeamMember deleted successfully!", data: response?.data };
        } catch (error) {
            if (error?.response?.data) {
                return { success: false, message: error?.response?.data?.message };
            } else {
                return { success: false, message: 'Sorry, something went wrong!' };
            }
        }
    },
);

const teamMemberSlice = createSlice({
    name: 'teamMember',
    initialState,
    reducers: {
        clearTeamMemberData: state => {
            state.data = [];
        },
        setTeamMemberData: (state, action) => {
            state.data = action.payload;
        },
       
    },
});

export const teamMemberReducer = teamMemberSlice.reducer;
export const { clearTeamMemberData, setTeamMemberData } = teamMemberSlice.actions;

export const selectTeamMemberData = (state) => state.teamMember.data;
